'use client';

import dynamic from 'next/dynamic';
import { usePriceHistoryContext } from './PriceHistoryProvider';

// markdown-it loads only when a listing actually has history with a disclaimer.
const PriceHistoryDisclaimerContent = dynamic(() =>
  import('./PriceHistoryDisclaimerContent').then((module) => module.PriceHistoryDisclaimerContent),
);

export function PriceHistoryDisclaimer() {
  const { history } = usePriceHistoryContext();
  return history?.events.length && history.listingDisclaimer ? (
    <PriceHistoryDisclaimerContent disclaimer={history.listingDisclaimer} />
  ) : null;
}
